import type { AgentAccount as AgentAccountModel } from '@/adapters/catalogv1.g';

export function extractAgentAccount(model: AgentAccountModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    agentRef: model.agent_ref ?? '',
    accountRef: model.account_ref ?? '',
    identityType: model.identity_type,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAgentAccount = ReturnType<typeof extractAgentAccount>;
